<template>
    <div>
        <div class="title-container">{{ project ? project.name : '' }}</div>
        <nav class="nav flex-column" v-if="!$route.meta.adminMenu">

            <router-link :to="{ name: 'projects-view', params: { id }}" class="nav-link dashboard" exact>
                Dashboard
            </router-link>
            <router-link v-if="hasManagerPermission('files.view')" :to="{ name: 'projects-files-index', params: { id }}" class="nav-link files">
                Files
            </router-link>

            <div class="dropdown-divider"></div>

            <router-link  v-if="hasManagerPermission('products.view')" :to="{ name: 'projects-products', params: { id }}" class="nav-link site-products">
                Products
            </router-link>

            <router-link v-if="hasManagerPermission('site_tools.view')" :to="{ name: 'site-tools-index', params: { id }}" class="nav-link site-tools">
                Site Tools
            </router-link>

            <div v-if="hasManagerPermission('products.view') || hasManagerPermission('site_tools.view')" class="dropdown-divider"></div>

            <router-link v-if="hasManagerPermission('reports.view')" :to="{ name: 'projects-reports-index', params: { id }}" class="nav-link reports">
                Reports
            </router-link>

            <router-link v-if="hasManagerPermission('site_monitoring.view')"  :to="{ name: 'projects-markings-index', params: { id }}"
                         class="nav-link site-monitoring">
                Site monitoring
            </router-link>



            <template v-if="hasManagerPermission('projects.publish') || hasManagerPermission('projects.unpublish') || hasManagerPermission('projects.delete')">
                <div class="dropdown-divider"></div>

                <div v-if="project.published_at && hasManagerPermission('projects.unpublish')"
                     class="nav-link publish-project"
                     @click="togglePublishState">
                    Unpublish project
                </div>

                <div v-else-if="!project.published_at && hasManagerPermission('projects.publish')"
                     class="nav-link publish-project"
                     @click="togglePublishState">
                    Publish project
                </div>

                <div v-if="hasManagerPermission('projects.delete')"
                     v-b-modal.remove-project-modal
                     class="nav-link delete-project">
                    Delete project
                </div>
            </template>

        </nav>
        <nav class="nav flex-column" v-else>
            <router-link :to="{ name: 'projects-index'}" class="nav-link" exact>
                Back to Dashboard
            </router-link>

            <router-link :to="{ name: 'company-details', params: { company_id: company_id }}" class="nav-link reports">
                Company Details
            </router-link>

            <router-link v-if="hasManagerPermission('projects.add_user')" :to="{ name: 'company-users-index', params: { company_id: company_id }}" class="nav-link reports">
                Company Users
            </router-link>

            <router-link :to="{ name: 'account', params: { company_id: company_id }}" class="nav-link reports">
                My Account
            </router-link>

            <template v-if="role && role < 3">
                <!--
                    <router-link :to="{ name: 'subscriptions-index', params: { company_id: company_id }}" class="nav-link reports">
                        Subscription
                    </router-link>

                    <a class="nav-link settings" href="javascript:void(0)">Settings</a>
                -->
            </template>
        </nav>

    </div>
</template>

<script>
    import '@css/settings-create-project.css';

    export default {
        props: {
            project: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                company_id: null,
                id: null,
                role: 3
            }
        },
        mounted() {
            this.id = this.project.id;
            this.role = this.$store.state.project.user.role;
            this.company_id = this.$store.state.company.id;
        },
        methods: {
            togglePublishState(state) {
                this.$bvModal.show('confirm-publish-modal');
            }
        },
        watch: {
            project(newProject) {
                this.id = this.project.id;
                this.company_id = this.$store.state.company.id;
            },
        }
    }
</script>
